import { MAX_CONTENT_KEYWORD_COUNT, MAX_CONTENT_KEYWORD_LENGTH } from '@diritto/common/content/constants';
import { reformatKeyword } from '@diritto/common/content/utils';
import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';
import { Input } from 'ui-components/common/Input';
import { ChangeEvent, useCallback, useState } from 'react';
import { DescriptionBlock } from 'ui-components/common/DescriptionBlock';

interface ContentKeywordInputProps {
  defaultValue?: string[];
  onChange: (value: string[]) => void;
}

export const ContentKeywordInput = ({ defaultValue = [], onChange }: ContentKeywordInputProps) => {
  const [inputKeyword, setInputKeyword] = useState(defaultValue.join(', '));

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const reformattedKeywords = value.split(',').map(it => reformatKeyword(it));
      setInputKeyword(reformattedKeywords.join(','));
      onChange(reformattedKeywords.filter(it => it));
    },
    [onChange],
  );

  return (
    <>
      <StyledKeywordInput
        placeholder="키워드1, 키워드2, 키워드3, 키워드4, 키워드5"
        onChange={handleChange}
        value={inputKeyword}
      />
      <StyledDescriptionBlock
        message={`키워드는 쉼표로 구분되며 최대 ${MAX_CONTENT_KEYWORD_COUNT}개만 입력할 수 있어요. 하나의 키워드는 ${MAX_CONTENT_KEYWORD_LENGTH}자를 넘을 수 없어요.`}
      />
    </>
  );
};

const StyledKeywordInput = styled(Input)`
  text-transform: uppercase;
  border: 1px solid ${Color.Gray300};
`;

const StyledDescriptionBlock = styled(DescriptionBlock)`
  margin-top: 16px;
`;
